import * as React from "react";
import { forwardRef } from "react";
const SvgAlignRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-text-align-end-icon lucide-text-align-end", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21 5H3" }), /* @__PURE__ */ React.createElement("path", { d: "M21 12H9" }), /* @__PURE__ */ React.createElement("path", { d: "M21 19H7" }));
const ForwardRef = forwardRef(SvgAlignRight);
export default ForwardRef;
